// src/data/translations.ts

import { Translations } from "../types";
import { BANANATALK_USERS_DISPLAY } from "./site-facts";

export const translations: Translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      experience: "Experience",
      projects: "Projects",
      certificates: "Certificates",
      liveProjects: "Live Projects",
      contact: "Contact",
    },
    hero: {
      greeting: "Hello, I'm",
      name: "Davis",
      title: "Full-Stack Developer · Seoul",
      subtitle:
        `I ship production web & mobile apps. ${BANANATALK_USERS_DISPLAY} users on my own products. 4+ years across React, Vue, Flutter, Node, and Django.`,
      cta: "Contact Me",
      resume: "Download Resume",
    },
    about: {
      title: "About Me",
      description:
        "Full-stack developer with 4+ years of experience building web and mobile applications with React, Vue.js, Next.js, Nuxt.js, Flutter, Node.js, and Django. I have shipped financial service platforms, insurance/loan management systems, and consumer marketplace apps — acting as both developer and project manager across the full lifecycle from planning to deployment.",
      extendedDescription:
        `Strong with REST API design, schema modeling, and complex business logic (commission calculations, workflow automation, multi-role permissions). I've led 4-5 person teams across multinational projects. Currently shipping TezSell (Flutter marketplace, live on App Store + Play Store) and BananaTalk (language exchange app, ${BANANATALK_USERS_DISPLAY} users across iOS and Android). 2nd-prize winner at HackSeoul 2025 for an AI clothing color-matching app.`,
      residence: "Work Authorization",
      languages: "Languages",
      residenceInfo:
        "Authorized to work in South Korea\nNo visa sponsorship required\nLong-term residence status",
      languageInfo: "English: Native level\nKorean: Advanced (KIIP Level 5)\nRussian: Conversational",
    },
    experience: {
      title: "Work Experience",
      current: "Current",
      achievements: "Key Achievements",
    },
    projects: {
      title: "Featured Projects",
      viewProject: "View Project",
      techStack: "Tech Stack",
      role: "Role",
    },
    contact: {
      title: "Get In Touch",
      subtitle: "Let's discuss your next project",
      email: "Email",
      phone: "Phone",
      location: "Location",
    },
  },
  ko: {
    nav: {
      home: "홈",
      about: "소개",
      experience: "경험",
      projects: "프로젝트",
      certificates: "자격증",
      liveProjects: "실제 프로젝트",
      contact: "연락처",
    },
    hero: {
      greeting: "안녕하세요, 저는",
      name: "데이비스",
      title: "풀스택 개발자 · 서울",
      subtitle:
        `프로덕션 웹 및 모바일 앱을 직접 출시합니다. 자체 제품에 ${BANANATALK_USERS_DISPLAY} 유저. React, Vue, Flutter, Node, Django로 4년 이상의 경험.`,
      cta: "연락하기",
      resume: "이력서 다운로드",
    },
    about: {
      title: "자기소개",
      description:
        "React, Vue.js, Next.js, Nuxt.js, Flutter, Node.js, Django로 4년 이상 웹 및 모바일 애플리케이션을 개발해온 풀스택 개발자입니다. 금융 서비스 플랫폼, 보험·대출 관리 시스템, 일반 소비자용 마켓플레이스 앱을 출시하며 개발과 프로젝트 매니저 역할을 모두 수행했습니다.",
      extendedDescription:
        `REST API 설계, 스키마 모델링, 복잡한 비즈니스 로직 구현(수수료 자동 계산, 워크플로우 자동화, 다중 권한 관리)에 강점이 있습니다. 다국적 프로젝트에서 4~5명 규모의 팀을 리드한 경험이 있으며, 현재 TezSell(Flutter, App Store·Play Store 출시)과 BananaTalk(언어 교환 앱, iOS·Android 합산 ${BANANATALK_USERS_DISPLAY} 유저)를 운영 중입니다. HackSeoul 2025에서 AI 의류 색상 매칭 앱으로 2위를 수상했습니다.`,
      residence: "근무 가능 자격",
      languages: "언어 능력",
      residenceInfo:
        "한국 내 합법 취업 가능\n스폰서십 불필요\n장기 거주 자격 보유",
      languageInfo: "영어: 원어민 수준\n한국어: 고급 (KIIP 5단계 수료)\n러시아어: 일상 회화 가능",
    },
    experience: {
      title: "주요 경험",
      current: "현재",
      achievements: "주요 성과",
    },
    projects: {
      title: "주요 프로젝트",
      viewProject: "프로젝트 보기",
      techStack: "기술 스택",
      role: "역할",
    },
    contact: {
      title: "연락하기",
      subtitle: "다음 프로젝트에 대해 논의해보세요",
      email: "이메일",
      phone: "전화",
      location: "위치",
    },
  },
  uz: {
    nav: {
      home: "Bosh sahifa",
      about: "Men haqimda",
      experience: "Tajriba",
      projects: "Loyihalar",
      certificates: "Sertifikatlar",
      liveProjects: "Faol loyihalar",
      contact: "Aloqa",
    },
    hero: {
      greeting: "Assalomu alaykum, men",
      name: "Davis",
      title: "Full-Stack Dasturchi · Seul",
      subtitle:
        `Ishlab chiqarish darajasidagi veb va mobil ilovalarni o'zim ishlab chiqaman. Shaxsiy mahsulotlarimda ${BANANATALK_USERS_DISPLAY} foydalanuvchi. React, Vue, Flutter, Node, Django bo'yicha 4+ yillik tajriba.`,
      cta: "Bog'lanish",
      resume: "Rezyumeni yuklab olish",
    },
    about: {
      title: "Men haqimda",
      description:
        "React, Vue.js, Next.js, Nuxt.js, Flutter, Node.js va Django yordamida 4 yildan ortiq veb va mobil ilovalar ishlab chiqish tajribasiga ega full-stack dasturchi. Moliyaviy xizmat platformalari, sug'urta/kredit boshqaruv tizimlari va iste'molchi bozor ilovalarini ishga tushirganman — rejalashtirishdan deployga qadar dasturchi va loyiha menejeri sifatida ishladim.",
      extendedDescription:
        `REST API loyihalash, sxema modellashtirish va murakkab biznes mantiqi (komissiya hisoblash, ish oqimini avtomatlashtirish, ko'p rolli ruxsatlar) sohalarida kuchli tajribaga egaman. Xalqaro loyihalarda 4-5 kishilik jamoalarni boshqarganman. Hozirda TezSell (Flutter bozor ilovasi, App Store va Play Store'da faol) va BananaTalk (til almashish ilovasi, iOS va Android'da jami ${BANANATALK_USERS_DISPLAY} foydalanuvchi) loyihalarini olib boryapman. HackSeoul 2025 da AI kiyim rang moslash ilovasi bilan 2-o'rin sovrindori.`,
      residence: "Ish ruxsati",
      languages: "Tillar",
      residenceInfo:
        "Janubiy Koreyada qonuniy ishlash huquqiga ega\nViza homiyligi talab qilinmaydi\nUzoq muddatli yashash maqomi",
      languageInfo: "Ingliz tili: Ona tili darajasi\nKoreys tili: Yuqori daraja (KIIP 5-daraja)\nRus tili: Suhbat darajasi",
    },
    experience: {
      title: "Ish tajribasi",
      current: "Hozirgi",
      achievements: "Asosiy yutuqlar",
    },
    projects: {
      title: "Asosiy loyihalar",
      viewProject: "Loyihani ko'rish",
      techStack: "Texnologiyalar",
      role: "Rol",
    },
    contact: {
      title: "Bog'lanish",
      subtitle: "Keyingi loyihangiz haqida gaplashaylik",
      email: "Elektron pochta",
      phone: "Telefon",
      location: "Manzil",
    },
  },
};
